import { render, staticRenderFns } from "./FulfillOrders.vue?vue&type=template&id=4568ec82"
import script from "./FulfillOrders.vue?vue&type=script&lang=js"
export * from "./FulfillOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports